import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Image } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";

import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, MODULE_ID_MAP, Notifications, START_PAGE, isModuleExist } from "../../utils/Constant";
import { deleteUserGroupApi, getAllUsergroupApi } from "./Api";
import UserGroupForm from "./UserGroupForm";
import { NOTIFICATION_GROUP_VERIFY } from "../../utils/urls";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class UserGroup extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.NotificationsUserGroup);
    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }

  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllUsergroupApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified) {

      this.setState({ currentPage: page }, () => {
        this.props.getAllUsergroupApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state?.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteUserGroupApi(id, this, this.openCloseDeleteModal)
  }
  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.groupName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.groupName}'`}
          show={this.state.show}
          url={NOTIFICATION_GROUP_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllUsergroupApi(this) }}
        />

        {
          //   true &&
          showEdit &&
          <UserGroupForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Group User"
          isSearch={false}
          placeholder={"Search User"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn={access.createAccess ? "Add Group User" : ''}
          handlePrimaryBtn={() => {

            this.setState({ showEdit: true })
          }}
          ctx={this}
        />

        <div className="commom-table-wrapper">

          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[

              {
                width: 250,
                title: "Group Name",
                dataIndex: "groupName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.groupName || "Na";
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.updatedBy?.name || 'Na';
                },
              },

              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.createdBy?.name || 'Na';
                },
              },

              {
                width: 20,
                title: "",
                fixed: "right",
                dataIndex: "",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      //  <div className="d-flex gap-3 justify-content-around">
                      //   {access.updateAccess && <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />}
                      //   {access.deleteAccess && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                      />
                    );
                },
              },
            ]}
           
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllUsergroupApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserGroup));
